module.exports = __webpack_public_path__ + "assets/7b63e123f989c6f357bee310ec4f73fb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/Colby_Dauphinais_Resume.pdf
// module id = 1007
// module chunks = 0